import { I18n } from "@workspace/core";
import { z } from "zod";

const { DEFAULT_LANGUAGE_CODE, LanguageCode, zLanguageCode } = I18n;
type LanguageCode = I18n.LanguageCode;

const zLanguage = z.enum(["english", "ukrainian", "german", "slovak", "russian"]);
const Language = zLanguage.Enum;
type Language = z.infer<typeof zLanguage>;

const SUPPORTED_LANGUAGES: Record<LanguageCode, Language> = {
  en: "english",
  uk: "ukrainian",
  de: "german",
  sk: "slovak",
  ru: "russian",
};

export {
  DEFAULT_LANGUAGE_CODE,
  Language,
  LanguageCode,
  SUPPORTED_LANGUAGES,
  zLanguage,
  zLanguageCode,
};
